import React from 'react';
import { observer } from 'mobx-react-lite';
import './eventDetailsPane.module.scss';
import { EyeCatch } from './components/EyeCatch';
import { EventDescription } from './components/EventDescription';
import { EventDetailsSection } from './components/EventDetailsSection';
import { FloatingEventInfo } from './components/FloatingEventInfo';
import { NotFoundPage } from '../../../../mainv2/containers/common/NotFoundPage';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { CoachProfile } from './components/CoachProfile';
import { useEventReservationState } from './states/EventPaneState';
import { BreadCrumb } from '../../../containers/breadcrumb/BreadCrumb';
import { V3Routes } from '../../../routes';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

type Props = {
  eventId: number;
};

export const EventDetails = observer((props: Props) => {
  const { event, alreadyReserved, eventWaitlistState } = useEventReservationState(props.eventId);
  if (event.isNotFound()) {
    return <NotFoundPage entityType="イベント" />;
  }
  if (event.loading) {
    return (
      <div styleName="pane">
        <LoaderRow />
      </div>
    );
  }
  const eventDetail = event.getOrThrow();
  const eventCoaches = eventDetail.coaches;
  const breadCrumbItems = [{ text: 'イベント', to: V3Routes.events() }, { text: eventDetail.title }];
  return (
    <div styleName="pane">
      {GlobalStatesV3.viewport.isMobile && (
        <div styleName="breadcrumb">
          <BreadCrumb items={breadCrumbItems} hasHome />
        </div>
      )}
      <EyeCatch event={eventDetail} />
      <div styleName="two-columns-container">
        <div styleName="right-column">
          <FloatingEventInfo
            eventId={props.eventId}
            alreadyReserved={alreadyReserved}
            eventWaitlistState={eventWaitlistState}
          />
        </div>
        <div styleName="left-column">
          <EventDetailsSection id="overview" title="概要">
            <EventDescription event={eventDetail} />
          </EventDetailsSection>
          {eventCoaches.length !== 0 && (
            <EventDetailsSection id="coaches" title="講師紹介">
              {eventCoaches.map((coach) => (
                <CoachProfile key={coach.id} coach={coach} />
              ))}
            </EventDetailsSection>
          )}
        </div>
      </div>
    </div>
  );
});
